import { Box, Typography, TableCell, TableRow } from '@mui/material';
import React, { useRef } from 'react';
import { List, AutoSizer, CellMeasurer, CellMeasurerCache } from 'react-virtualized';
import ModalHeader from '../../common/Header';

const SeatAllocationRow = ({ data, columns, index, style }) => (
    <TableRow style={style} key={index}>
        {columns.map((col, colIndex) => (
            <TableCell key={colIndex} sx={{ fontSize: '14px', textAlign: col.align || 'left' }}>
                {data[index][col.field]}
            </TableCell>
        ))}
    </TableRow>
);

const SeatAllocationTable = ({ title, data, columns }) => {
    const cache = useRef(new CellMeasurerCache({
        fixedWidth: true,
        defaultHeight: 50
    }));

    const rowRenderer = ({ index, key, parent, style }) => (
        <CellMeasurer
            key={key}
            cache={cache.current}
            parent={parent}
            rowIndex={index}
        >
            {() => <SeatAllocationRow data={data} columns={columns} index={index} style={style} />}
        </CellMeasurer>
    );

    return (
        <Box sx={{ padding: '10px', textAlign: 'center', color: 'red' }}>
            <Typography sx={{ fontSize: '14px', fontWeight: 600 }}>{title}</Typography>
            <Box sx={{ width: '100%', height: 'calc(100vh - 110px)' }}>
                <AutoSizer>
                    {({ height, width }) => (
                        <List
                            width={width}
                            height={height}
                            rowCount={data.length}
                            rowHeight={cache.current.rowHeight}
                            rowRenderer={rowRenderer}
                            deferredMeasurementCache={cache.current}
                            overscanRowCount={5}
                        />
                    )}
                </AutoSizer>
            </Box>
        </Box>
    );
};

const BookingSummaryDetails = ({ reportData = {}, handleBack }) => (
    <Box>
        <ModalHeader headerText="Booking Summary Report" showBackArrow onBackClick={handleBack} />
        <Box sx={{ paddingTop: "60px" }}>
            {reportData?.Table?.map((obj, index) => (
                <Box key={index} sx={{ marginBottom: '20px' }}>
                    <Box sx={{ padding: '10px', backgroundColor: '#EDF7FF' }}>
                        <Typography sx={{ fontSize: '14px', padding: '4px 0px' }}>Route: {obj?.RouteName}</Typography>
                        <Typography sx={{ fontSize: '14px', padding: '4px 0px' }}>Chart Name: {obj?.ChartName}</Typography>
                        <Box sx={{ display: 'flex', gap: '10px' }}>
                            <Typography sx={{ fontSize: '14px', padding: '4px 0px' }}>Bus Number: {obj?.BusNo}</Typography>
                            <Typography sx={{ fontSize: '14px', padding: '4px 0px' }}>Bus Adv: {obj?.BusPayment}</Typography>
                        </Box>
                    </Box>

                    <SeatAllocationTable
                        title="Sub-Route Wise Seat Allocation"
                        data={[obj]}
                        columns={[
                            { label: "Sub-Route", field: "SubRouteName", width: "40%" },
                            { label: "Bkd Seats", field: "TotalSeats", width: "30%", align: "center" },
                            { label: "Seats", field: "SeatsBooked", width: "30%", align: "center" },
                        ]}
                    />

                    <SeatAllocationTable
                        title="Branch Wise Seat Allocation"
                        data={reportData?.Table1 || []}
                        columns={[
                            { label: "Branch", field: "BranchName", width: "40%" },
                            { label: "Bkd Seats", field: "TotalSeats", width: "30%", align: "center" },
                            { label: "Seats", field: "SeatsBooked", width: "30%", align: "center" },
                        ]}
                    />
                </Box>
            ))}
        </Box>
    </Box>
);

export default BookingSummaryDetails;
